module.exports = __webpack_public_path__ + "img/br.8488663d.jpg";